// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { EnvConfig } from '../environment.interface';

export const environment: EnvConfig = {
  ENV: 'STAGING',
  PUBLIC_API: 'https://public-api.devheroo.com',
  TRAVELER_API: 'https://traveler-api.devheroo.com',
  TRAVELER_UI: 'https://app.devheroo.com',
  IDENTITY_API: 'https://identity-api.devheroo.com',
  IDENTITY_ST_API: 'https://identity-st-api.devheroo.com',
  DASHBOARD_API: 'https://dashboard-api.devheroo.com',
  DASHBOARD_UI: 'https://dashboard.devheroo.com',
  LANDING_UI: 'https://devheroo.com',
  STORAGE_MANAGER_API: 'https://storage-manager-api.devheroo.com',
  LANDING_URL: 'https://landing.devheroo.com',
  IMAGES_BASE_URL: 'https://static.luggagehero.com',
  FACEBOOK_APP_ID: '546972105509031',
  STRIPE_PUBLISHABLE_KEY: 'pk_test_yAJnAA4ZodC4dFPPlulY1CIR',
  BOOKINGSYNC_CLIENT_ID: '8f6c249144dc22a96ba2994ef1485fce603a878605abcdf2997516dfd54540c7',
  BOOKINGSYNC_OAUTH_URL: 'https://www.bookingsync.com/oauth/authorize',
  BOOKINGSYNC_OAUTH_REDIRECT_URI: 'https://partner.devheroo.com/bookingsync/admin',
  PMS_INTEGRATIONS_API: 'https://pms-integrations-api.devheroo.com',
  GOOGLE_WEB_CLIENT_ID: '595935798811-bkojh18ok4unniqh1okq8p0q1fbbqp4m.apps.googleusercontent.com',
  INTERCOM_APP_ID: 'gumq1av0',
  CRYPTO_KEY: '3339716b746769573331436d3670697a6d6a6b45746a324f7656307845514970',
  DATADOG_CLIENT_TOKEN: 'pubc6008b30608b6418df348967dbc28a00',
  DATADOG_SITE: 'datadoghq.com',
  APPSFLYER_DEV_KEY: '3cZegDZXa7K8NKLYvFLpvK',
  APPSFLYER_APP_ID: '1481057935',
  DASHBOARD_APP_ANDROID_URL: 'https://play.google.com/store/apps/details?id=com.luggagehero.dashboard',
  DASHBOARD_APP_IOS_URL: 'https://apps.apple.com/us/app/luggagehero-dashboard/id6760704859',
};
